import { RequestResponse } from "utils/base_api";

import * as ignoredTopicsApi from "api/ignored_topics";

import { useState } from "react";

import { useQueryClient } from "react-query";

export function useIgnore(): {
  ignoreTopic: (topicSlug: string, parentSlug: string) => Promise<void>;
  deleteTopicIgnore: (id: string) => Promise<void>;
  invalidateTasksQuery: () => void;
  isLoading: boolean;
  response: RequestResponse;
} {
  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const queryClient = useQueryClient();

  async function ignoreTopic(topicSlug: string, parentSlug: string) {
    setIsLoading(true);
    return ignoredTopicsApi.create(topicSlug, parentSlug).then((response) => {
      setResponse(response);
      setIsLoading(false);
    });
  }

  async function deleteTopicIgnore(id: string) {
    setIsLoading(true);
    return ignoredTopicsApi.destroy(id).then((response) => {
      setResponse(response);
      setIsLoading(false);
    });
  }

  function invalidateTasksQuery() {
    queryClient.invalidateQueries("study_plan_tasks");
  }

  return {
    ignoreTopic,
    deleteTopicIgnore,
    invalidateTasksQuery,
    isLoading,
    response
  };
}
